import React from 'react'
import Hero from './Hero'
import heroPost from '../../../../5pageAssets/images/blog/hero-post.png'

const AutoReplyComments = () => {
  const question = "How to auto-reply to comments on Facebook/Instagram posts"
  const benefits = [
    {
      icon: (
        <svg
          className="w-10 h-10 text-primary"
          viewBox="0 0 24 24"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          {' '}
          <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
            {' '}
            <rect id="bound" x={0} y={0} width={24} height={24} />{' '}
            <path
              d="M13.0799676,14.7839934 L15.2839934,12.5799676 C15.8927139,11.9712471 16.0436229,11.0413042 15.6586342,10.2713269 L15.5337539,10.0215663 C15.1487653,9.25158901 15.2996742,8.3216461 15.9083948,7.71292558 L18.6411989,4.98012149 C18.836461,4.78485934 19.1530435,4.78485934 19.3483056,4.98012149 C19.3863063,5.01812215 19.4179321,5.06200062 19.4419658,5.11006808 L20.5459415,7.31801948 C21.3904962,9.0071287 21.0594452,11.0471565 19.7240871,12.3825146 L13.7252616,18.3813401 C12.2717221,19.8348796 10.1217008,20.3424308 8.17157288,19.6923882 L5.75709327,18.8875616 C5.49512161,18.8002377 5.35354162,18.5170777 5.4408655,18.2551061 C5.46541191,18.1814669 5.50676633,18.114554 5.56165376,18.0596666 L8.21292558,15.4083948 C8.8216461,14.7996742 9.75158901,14.6487653 10.5215663,15.0337539 L10.7713269,15.1586342 C11.5413042,15.5436229 12.4712471,15.3927139 13.0799676,14.7839934 Z"
              id="Path-76"
              fill="currentcolor"
            />{' '}
            <path
              d="M14.1480759,6.00715131 L13.9566988,7.99797396 C12.4781389,7.8558405 11.0097207,8.36895892 9.93933983,9.43933983 C8.8724631,10.5062166 8.35911588,11.9685602 8.49664195,13.4426352 L6.50528978,13.6284215 C6.31304559,11.5678496 7.03283934,9.51741319 8.52512627,8.02512627 C10.0223249,6.52792766 12.0812426,5.80846733 14.1480759,6.00715131 Z M14.4980938,2.02230302 L14.313049,4.01372424 C11.6618299,3.76737046 9.03000738,4.69181803 7.1109127,6.6109127 C5.19447112,8.52735429 4.26985715,11.1545872 4.51274152,13.802405 L2.52110319,13.985098 C2.22450978,10.7517681 3.35562581,7.53777247 5.69669914,5.19669914 C8.04101739,2.85238089 11.2606138,1.72147333 14.4980938,2.02230302 Z"
              id="Combined-Shape"
              fill="currentcolor"
              opacity="0.3"
            />{' '}
          </g>{' '}
        </svg>
      ),
      title: 'Technical Support',
      description:
        'Our professional technical support team will help you out at every step',
    }
  ]
  return (
    <div>
      <Hero question={question} />
      <section className="lg:py-24 py-16">
        <div className="container" data-aos="fade-up">
          <div className="grid lg:grid-cols-3 grid-cols-1 gap-10">
            <div className="flex flex-col items-center lg:items-start">
              <div className="border-t-2 border-gray-300 w-1/5 mb-7" />
              <h1 className="text-3xl">In this article</h1>
            </div>
            <div>
              <p className=" text-gray-600">
                <div>
                  {benefits.map((benefit, index) => (
                    <div
                      key={index} // Use a unique key for each item
                      className="flex gap-6 items-center"
                      data-aos="fade-up"
                      data-aos-duration={300}
                    >
                      <div>
                        <span className=" bg-primary/10 rounded-md flex items-center justify-center">
                          {benefit.icon}
                        </span>
                      </div>
                      <div>
                        <h4 className="mb-1 mt-3">{benefit.title}</h4>
                        <p className="text-slate-400 ">{benefit.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </p>
            </div>
            <div>
              <p className="text-sm/relaxed tracking-wider text-gray-600">
                <h5 className="text-base">Automating Customer Engagement</h5>
                <p className="flex items-center gap-2 text-slate-400 font-medium mt-3">
                  <i className="fa-solid fa-minus" />
                  Your Messenger chatbot can automatically comment on posts and reply to messages, improving response time and customer experience.
                </p>
              </p>
            </div>
          </div>
          <div className="lg:mt-5">
            <div className="grid lg:grid-cols-3 grid-cols-1 gap-10">
              <div />
              <div className="lg:col-span-2">
                <p className="text-sm/relaxed tracking-wider text-slate-400">
                  You can set up Facebook comment automation on a specific page post, all page posts, reels, or Fb Ads. This tool helps your business to increase engagement with your audience    </p>
              </div>
            </div>
          </div>
          <div className='pt-25 pb-20'>
            <div className="items-center border-y py-8 mt-14 ">
              To manage Instagram messages via Chatrace, Instagram business accounts must enable the connected tools to toggle under message control settings.
            </div>
          </div>
          <div >
            <img src={heroPost} className="rounded-md" />
          </div>
          <div className='pt-25 pb-20'>
            <div className="items-center border-y py-8 mt-14 ">
              <div>
                Connect your Instagram Professional account to SocialChat.
              </div>
            </div>
          </div>
          <div >
            <img src={heroPost} className="rounded-md" />
          </div>
        </div>
      </section >
    </div>
  )
}

export default AutoReplyComments
